
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getStates",
      resolverType: "query",
      routePath: "/getStates",
      httpMethod: "POST",
    });
  